/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

import moment from 'moment';
import _ from 'lodash';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";

import {
  Container,
  Row,
  Col,
  Button,
  Spinner
} from 'reactstrap';

import { Icon } from '@material-ui/core';

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown';
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";

// styles
import { grayColor } from "assets/jss/material-dashboard-pro-react.jsx";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withAuthentication } from "contexts/Session";
import { getUser } from "db";
import { upsertUser } from "db";

import SweetAlert from "react-bootstrap-sweetalert";
import { uploadFile } from "helpers/storage";
import { getRole } from "db";
import { updateMember } from "db";
import { MEMBER_STATUS } from "constants/member.js";

import * as httpHelper from "helpers/https";
import { toE164 } from "helpers/phoneNumber";
import {
  verifyEmail,
  verifyPhoneNumber,
  verifyDate,
} from "components/Form/DXFormValidator";
import { ROLES } from "constants/user";
import { ROLES_STRING } from "constants/user";
import { USER_STATUS_STRING } from "constants/user";
import { fromE164 } from "helpers/phoneNumber";

const styles = theme => ({
  ...userProfileStyles,
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },
  group: {
    margin: theme.spacing(1, 0),
    flexDirection: 'row',
  },
  dateInput: {
    fontSize: '14px',
    border: 0,
  },
  inputLabel: {
    padding: '10px',
    backgroundColor: 'red'
  }
});

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        profile_image_url: '',
        name: '',
        birthday: '',
        gender: null,
        email: '',
        phone: '',
        intro: '',
      },
      alert: null,
      errorMessage: '필수 내용을 모두 채워주세요',
      isSaving: false,
    }
  }

  async componentDidMount() {
    const { user_id = this.props.location ? this.props.location.state.user_id : null } = this.props;
    if (user_id) {
      await getUser(user_id)
        .then(user => {
          const userData = user.data();
          userData.phone = fromE164(userData.phone);
          this.setState({ user: userData, errorMessage: null });
        })
        .catch(e => console.error(e))
    }
  }

  basicAlert = (message) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{
            marginBottom: "3px",
            color: grayColor[2],
            fontSize: "18px",

            display: "block",
            marginTop: "-100px",
          }}
          title={message}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        />
      )
    });
  }

  successAlert = (message) => {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="저장되었습니다"
          onConfirm={() => this.props.requestClose()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          유저 프로필이 저장되었습니다.<br />감사합니다.
        </SweetAlert>
      )
    });
  }

  hideAlert = () => {
    this.setState({
      alert: null
    });
  }

  checkValid = () => {
    const { user } = this.state;
    const { name, email, phone, gender, birthday } = user;

    console.log('state.user = ', user);

    if (!name || name.length < 2) {
      this.setState({ errorMessage: '이름을 제대로 입력해주세요.' });
      return false;
    }

    if (gender === null || !(gender === 0 || gender === 1)) {
      this.setState({ errorMessage: '성별을 제대로 선택해주세요.' });
      return false;
    }

    if (!email || !verifyEmail(email)) {
      this.setState({ errorMessage: '이메일을 제대로 입력해주세요.' });
      return false;
    }

    if (!phone || !verifyPhoneNumber(phone)) {
      this.setState({ errorMessage: '전화번호를 제대로 입력해주세요.' });
      return false;
    }

    if (!birthday || !verifyDate(birthday)) {
      this.setState({ errorMessage: '생년월일을 제대로 입력해주세요.' });
      return false;
    }

    this.setState({ errorMessage: null });
    return true;
  }

  save = async () => {
    if (!this.checkValid()) {
      this.basicAlert(this.state.errorMessage);
      return;
    }

    this.setState({ isSaving: true });

    console.log('this.state = ', this.state);
    const { user_id = this.props.location ? this.props.location.state.user_id : null } = this.props;
    const { user, file } = this.state;
    const { name, email, phone } = user;
    const birthday = user.birthday
      ? user.birthday.constructor.name !== "String"
        ? moment(user.birthday?.toDate()).format("YYYY-MM-DD")
        : user.birthday
      : null

    if (user_id) {
      if (file) {
        try {
          const url = await uploadFile(file, `userdata/${user_id}/public/profile`);
          await upsertUser(user_id, {
            ...user,
            profile_image_url: url,
            birthday
          });
          const role = await getRole(user_id);
          const { orgs = [] } = role;
          await Promise.all(orgs.map(org_id => updateMember(org_id, user_id, {
            ...user,
            org_id,
            profile_image_url: url,
            birthday,
          })));
          this.successAlert();
        } catch (error) {
          this.basicAlert(error);
        } finally {
          this.setState({ isSaving: false });
        }
      } else { // with no file attachment
        try {
          await upsertUser(user_id, {
            ...user,
            birthday
          })
          const role = await getRole(user_id);
          const { orgs = [] } = role;
          await Promise.all(orgs.map(org_id => updateMember(org_id, user_id, {
            ...user,
            org_id,
            birthday,
          })));
          this.successAlert();
        } catch (error) {
          this.basicAlert(error);
        } finally {
          this.setState({ isSaving: false });
        }
      }
    } else {
      // new user
      if (file) {
        try {
          const url = await uploadFile(file, `temp/user_profile_images/${+new Date()}`);
          const { userRecord } = await httpHelper.createUser({
            name,
            email,
            phone: toE164(phone),
            profile_image_url: url
          });
          console.log(`url = ${url}`);
          console.log("userRecord = ", userRecord);
          await upsertUser(userRecord.uid, {
            ...user,
            profile_image_url: url,
            birthday
          });
          this.successAlert();
        } catch (error) {
          this.basicAlert(error);
          console.error("failed to createUser: ", error);
        } finally {
          this.setState({ isSaving: false });
        }
      } else {
        try {
          const { userRecord } = await httpHelper.createUser({
            name,
            email,
            phone: toE164(phone),
          });
          console.log("userRecord = ", userRecord);
          await upsertUser(userRecord.uid, {
            ...user,
            birthday
          });
          this.successAlert();
        } catch (error) {
          this.basicAlert(error);
          console.error("failed to createUser: ", error);
        } finally {
          this.setState({ isSaving: false });
        }
      }
    }
  }

  onFileLoaded = (file, isRemoved = false) => {
    if (isRemoved) {
      this.setState({ file: null, user: { ...this.state.user, profile_image_url: null } });
    } else {
      this.setState({ file });
    }
  }

  render() {
    const { user } = this.state;
    const { classes, isEdit = true } = this.props;
    return (
      <Container className='bg-transparent'>
        <Row>
          <Col className='p-3'>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <Row>
                  <Col>
                    <h4 className={classes.cardIconTitle}>
                      사용자 정보 {isEdit ? '편집' : '등록'}
                    </h4>
                  </Col>
                  <Col xs={{ size: 'auto' }}>
                    <Icon color={'primary'} onClick={this.props.requestClose} style={{ cursor: 'pointer', marginTop: 10 }}>close</Icon>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row justify='center'>
                  <Col className={'text-center mt-4 col-4'}>
                    <ImageUpload
                      avatar
                      addButtonProps={{
                        color: "rose",
                        round: true
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true
                      }}
                      imageUrl={user.profile_image_url}
                      onFileLoaded={(file, isRemoved = false) => this.onFileLoaded(file, isRemoved)}
                    />
                  </Col>
                  <Col className='mr-5'>
                    <Row>
                      <Col>
                        <CustomInput
                          labelText="이름"
                          id="name"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            disabled: false,
                            value: user.name,
                            onChange: event => {
                              this.setState({ user: { ...user, name: event.target.value } }, this.checkValid);
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormControl component="fieldset" className={styles.formControl}>
                          {/* <FormLabel component="legend">성별</FormLabel> */}
                          <RadioGroup
                            aria-label="gender"
                            name="gender"
                            value={String(user.gender)}
                            onChange={event => {
                              this.setState({ user: { ...user, gender: Number(event.target.value) } }, this.checkValid);
                            }}
                          >
                            <div className={'d-inline-flex align-items-center'}>
                              <label className='mr-5'>성별</label>
                              <FormControlLabel value="0" control={<Radio />} label="여자" />
                              <FormControlLabel value="1" control={<Radio />} label="남자" />
                            </div>
                          </RadioGroup>
                        </FormControl>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <CustomInput
                          labelText="이메일 주소"
                          id="email-address"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            disabled: isEdit,
                            value: user.email,
                            onChange: event => {
                              this.setState({ user: { ...user, email: event.target.value } }, this.checkValid);
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Row>
                          <Col className='col-auto d-flex justify-content-baseline align-items-center'>
                            <label>생년월일</label>
                          </Col>
                          <Col>
                            <CustomInput
                              id="birthday"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: 'date',
                                value: user.birthday
                                  ? user.birthday.constructor.name === 'String'
                                    ? user.birthday
                                    : moment(user.birthday?.toDate()).format('YYYY-MM-DD')
                                  : '',
                                onChange: event => {
                                  this.setState({ user: { ...user, birthday: event.target.value } }, this.checkValid);
                                }
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <CustomInput
                          labelText="전화번호"
                          id="phone"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            disabled: isEdit,
                            value: user.phone,
                            onChange: event => {
                              this.setState({ user: { ...user, phone: event.target.value } }, this.checkValid);
                            },
                            onBlur: this.checkValid
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col className='ml-5 mr-5'>
                    <CustomInput
                      labelText="자기소개"
                      id="about-me"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        value: user.intro,
                        onChange: event => {
                          this.setState({ user: { ...user, intro: event.target.value } }, this.checkValid);
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {
                      this.state.errorMessage
                        ? <div className='text-center text-danger'>{this.state.errorMessage}</div>
                        : null
                    }
                  </Col>
                </Row>
                {
                  [ROLES.SUPER_ADMIN].includes(this.props.currentRole?.role)
                    ? <Row className='mt-3'>
                      <Col className='col-6 ml-5 mr-5'>
                        <div className='text-center d-inline-flex justify-content-center align-items-center'>
                          <label className='mr-5'>현재 상태</label>
                          <CustomDropdown
                            buttonText={USER_STATUS_STRING[this.state.user["status"]]}
                            hoverColor="info"
                            buttonProps={{
                              round: true,
                              block: true,
                              color: "primary"
                            }}
                            dropPlacement="bottom"
                            dropdownList={USER_STATUS_STRING}
                            onClick={(params) => {
                              const status = _.findIndex(USER_STATUS_STRING, o => o == params);
                              const { user } = this.state;
                              user.status = status;
                              this.setState({ user });
                              console.log("params = ", params);
                              console.log("status = ", status);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    : null
                }
                <Row>
                  <Col>
                    <Button color={'light'} onClick={this.props.requestClose}>취소</Button>
                    <Button
                      color="primary"
                      disabled={Boolean(this.state.errorMessage)}
                      className={classes.updateProfileButton}
                      onClick={this.save}

                    >
                      {isEdit ? '프로필 저장하기' : '등록하기'}
                      {
                        this.state.isSaving
                          ? <Spinner size="sm" color="light" />
                          : null
                      }
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {this.state.alert}
      </Container >
    )
  }
}
UserProfile.propTypes = {
  classes: PropTypes.object,
  user_id: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    currentOrg: state.org.currentOrg,
    currentUser: state.auth.currentUser,
    currentRole: state.auth.currentRole,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withAuthentication,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(UserProfile);
